<template>
    <div>
        <h1>Greetings, developer!</h1>
        <p>Your task is to build the perfect serverless kitchen in the cloud! One step at a time, though.</p>
        <p>It does not matter if you are a Backend Developer, Frontend Developer, or perhaps someone interested in test automation.</p>
        <p>Need help? Want to discuss solutions or share your creation? Visit <a href="https://afitwest.slack.com/archives/CREFZN18C" target="_blank">#serverless-kitchen</a>. Any feedback or suggestions would be greatly appreciated!</p>
        <h3>Are you up for the challenge?</h3>
        <LinkBox>
            <li><router-link to="/story">Yes, continue</router-link></li>
        </LinkBox>
        <img alt="Yummy!" src="../assets/logo.png">
    </div>
</template>

<script>
import LinkBox from '@/components/LinkBox.vue'

export default {
    name: 'intro',
    components: {
        LinkBox
    }
}
</script>

<style scoped>
img {
    width:76px;
    height:76px;
}
</style>